import { useEffect, useState } from "react";
import UserMenuPageTitle from "../shared/user-menu/UserMenuPageTitle";
import { SVLS_API_CLIENT } from "../../../App.utils";
import { BRAND_DOMAIN } from "../../../constants/Branding";
import { AxiosResponse } from "axios";
import PromotionCard from "./PromotionCard";

import Modal from "../shared/ModalComponent";
import { setAlertMsg, useAppDispatch, useAppSelector } from "@hypexone/uicore";
export type BannerObjData = {
  id: number;
  houseId: number;
  bannerId: string;
  sportsBookUrl: string;
  title: string;
  category: string;
  deviceType: string;
  level: number;
  publicUrl: string;
  redirectionUrl: string;
  imageContent: string;
  displayContent: string;
  active: boolean;
};

export type BannerResData = {
  banners: BannerObjData[];
};
const RenderHtml = ({ htmlString }) => {
  return <div dangerouslySetInnerHTML={{ __html: htmlString }} />;
};
export const Promotions = () => {
  const [promotionBanners, setPromotionBanners] = useState<BannerObjData[]>([]);
  const [showKnowMoreModal, setShowMoreModal] = useState(false);
  const [promotionDisplayData, setPromotionDisplayData] = useState("");
  const dispatch = useAppDispatch();
  const { langData } = useAppSelector((state) => state.cms);
  const getPromotionBanners = async () => {
    const bannersRes: AxiosResponse<BannerResData> = await SVLS_API_CLIENT.get(
      `/account/v2/books/${BRAND_DOMAIN}/banners`,
      {
        params: {
          category: "Recommendedbanner",
          status: "active",
          type: "desktop",
        },
      }
    );
    const banners = bannersRes.data.banners;
    setPromotionBanners(banners);

  };

  useEffect(() => {
    getPromotionBanners();
  }, []);
  const handleKnowMoreClick = (bannerInfo: BannerObjData) => {
    const promotionDisplayContent = bannerInfo.displayContent;

    if (promotionDisplayContent) {
      setPromotionDisplayData(promotionDisplayContent);
      setShowMoreModal(true);
    } else {
      dispatch(
        setAlertMsg({
          type: "error",
          message: "No display content",
        })
      );
    }
  };
  return (
    <>
      <UserMenuPageTitle title={langData?.['promotions']} />
   {promotionBanners.length > 0 && (
  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-1 w-full">
    {promotionBanners.map((banner, index) => (
      <PromotionCard
        key={index}
        bannerData={banner}
        onKnowMorePress={handleKnowMoreClick}
      />
    ))}
  </div>
)}


      <Modal
        isOpen={showKnowMoreModal}
        onClose={() => setShowMoreModal(false)}
        title={langData?.['promotion_info']}
      >
        <div className="promotions-modal-ctn">
          <RenderHtml htmlString={promotionDisplayData} />
        </div>
      </Modal>
    </>
  );
};
